import Card from "./card";
import { Box } from "@mui/material";
import styles from "./style.module.css";
import { useSelector } from "react-redux";

const Liked = () => {
  const {
    data: { likedProjects },
  } = useSelector((state) => state.manageProjects);

  const renderProjects = likedProjects?.map((project, index) => {
    return <Card project={project} key={index} />;
  });

  return <Box className={styles.liked}>{renderProjects}</Box>;
};

export default Liked;
